export default "__VITE_PUBLIC_ASSET__0460db26__"